export enum FormField {
  CountryCode = `countryCode`,
  PhoneNumber = `phoneNumber`,
  VerificationCode = `verificationCode`,
}

export interface FormValues {
  [FormField.CountryCode]: string;
  [FormField.PhoneNumber]: string;
  [FormField.VerificationCode]: string;
}

export enum TwoFactorStep {
  Setup = 0,
  Verify = 1,
}

type ValidationError = string | null;

export interface FormErrors {
  [FormField.CountryCode]: ValidationError;
  [FormField.PhoneNumber]: ValidationError;
  [FormField.VerificationCode]: ValidationError;
}

export function isRequired(name, value): ValidationError {
  return !value.length ? `${name} is required.` : null;
}

export function getAllValidationErrors(formValues: FormValues, step: TwoFactorStep): FormErrors {
  if (step === TwoFactorStep.Setup) {
    return {
      [FormField.CountryCode]: isRequired(`Country code`, formValues.countryCode),
      [FormField.PhoneNumber]: isRequired(`Phone number`, formValues.phoneNumber),
      [FormField.VerificationCode]: null,
    };
  }

  return {
    [FormField.CountryCode]: null,
    [FormField.PhoneNumber]: null,
    [FormField.VerificationCode]: isRequired(`Verification code`, formValues.verificationCode),
  };
}
